const LETTERS_AND_SPACES_PATTERN = /^[A-Za-zÁÉÍÓÚáéíóúÑñÜü ]*$/;
const NON_LETTER_OR_SPACE_PATTERN = /[^A-Za-zÁÉÍÓÚáéíóúÑñÜü ]/g;

export const isLettersAndSpacesOnly = (value: string): boolean => LETTERS_AND_SPACES_PATTERN.test(value);

export const toLettersAndSpacesOnly = (value: string): string =>
  value.normalize('NFC').replace(NON_LETTER_OR_SPACE_PATTERN, '');
